/* nt-smooth-load.js — 2026-03-29 — REVERT: remove 2 lines before </head> in theme.liquid */
(function () {
  var ready = false;

  function init() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        // Only animate cards that come into view AFTER page has settled
        if (ready) entry.target.classList.add('nt-animate-in');
        entry.target.classList.add('nt-seen');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.nt_pr:not(.nt-seen)').forEach(function (el) {
      io.observe(el);
    });

    // After 200ms, anything newly entering the viewport gets animated
    setTimeout(function () { ready = true; }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Handle AJAX-loaded products (filters, infinite scroll)
  new MutationObserver(function (muts) {
    var found = false;
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if ((n.classList && n.classList.contains('nt_pr')) ||
            (n.querySelector && n.querySelector('.nt_pr'))) found = true;
      });
    });
    if (found) init();
  }).observe(document.body, { childList: true, subtree: true });
})();
